/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import Trans from 'next-translate/Trans'
import dynamic from 'next/dynamic'

import styles from './../style.module.scss'
import { allRoutes } from '@shared/constants/allRoutes'
import { useLazyQuery } from '@apollo/client'
import { isBottomReached, mapArticleData } from '@utils'
import { HOME_PAGE_ARTICLE } from '@graphql/home/home.query'
import { articleLoader } from '@shared/libs/allLoader'
import useWindowSize from '@shared/hooks/windowSize'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

const ArticleBig = dynamic(() => import('@shared/components/article/articleBig'), { loading: () => articleLoader(['g']) })
const ArticleSmall = dynamic(() => import('@shared/components/article/articleSmall'), { loading: () => articleLoader(['s']) })
const ArticleGrid = dynamic(() => import('@shared/components/article/articleGrid'), { loading: () => articleLoader(['g']) })
const ArticleMedium = dynamic(() => import('@shared/components/article/articleMedium'))
const ArticleList = dynamic(() => import('@shared/components/article/articleList'))
const AllWidget = dynamic(() => import('@shared/components/allWidget'), { ssr: false })
// const Ads = dynamic(() => import('@shared/components/ads'), { ssr: false })
const DownloadBanner = dynamic(() => import('@shared/components/downloadBanner'))
const LiveMatchCard = dynamic(() => import('@shared/components/liveMatchCard'))
const CustomLink = dynamic(() => import('@shared/components/customLink'))

function HomePageArticle({ articles, widgetPosition }) {
  const homeData = {
    nDuration: 3,
    dPublishDisplayDate: 1691416800739,
    sSrtTitle: 'The Hundred 2023: Match 11, LNS vs SOB Match Prediction',
    sTitle: 'The Hundred Men 2023: Match 11, LNS vs SOB Match Prediction – Who will win today’s match between LNS vs SOB?'
  }

  const [article, setArticle] = useState(mapArticleData(articles))
  const [loading, setLoading] = useState(false)
  const payload = useRef({ nLimit: 5, nSkip: 1 })
  const total = useRef(4)
  const isLoading = useRef(false)
  const [width] = useWindowSize()
  const { stateGlobalEvents } = useContext(GlobalEventsContext)

  // const { data, fetchMore } = useQuery(HOME_PAGE_ARTICLE, { variables: { input: payload.current } })
  const [fetchMore, { data }] = useLazyQuery(HOME_PAGE_ARTICLE, { variables: { input: payload.current } })

  // const latestArticle = data?.getHomePageArticle?.aResults?.length

  useEffect(() => {
    isLoading.current = false
    setLoading(false)
    isBottomReached(article[article.length - 1]?.sSlug, isReached)
  }, [article])

  useEffect(() => {
    if (data?.getHomePageArticle) {
      handleArticleResponse(data?.getHomePageArticle)
    }
  }, [data])

  useEffect(() => {
    if (stateGlobalEvents?.homeArticle?.length) {
      const cloneArticls = article
      stateGlobalEvents?.homeArticle.forEach((match) => {
        let currentMatch = cloneArticls.find((item) => item?.oScore?.iMatchId === match?.iMatchId)
        if (currentMatch) {
          currentMatch = { ...currentMatch, oScore: { ...currentMatch?.oScore, ...match } }
          const index = cloneArticls.findIndex((s) => s?.iSeriesId === currentMatch?.iSeriesId)
          cloneArticls[index] = currentMatch
        }
      })
      setArticle(cloneArticls)
    }
  }, [stateGlobalEvents])

  async function isReached(reach) {
    if (reach && !isLoading.current && total.current !== 0) {
      isLoading.current = true
      setLoading(true)
      payload.current.nSkip += 1
      fetchMore({
        variables: { input: { ...payload.current } }
      })
    }
  }

  function handleArticleResponse(data) {
    total.current = data?.aResults?.length
    setArticle([...article, ...mapArticleData(data?.aResults)])
  }

  function getCustomURL(aCustomSeo = []) {
    const URLs = {}
    aCustomSeo?.forEach((e) => {
      URLs[e?.eTabType] = `/${e?.sSlug}/`
    })
    return URLs
  }
  return (
    <>
      {article?.map((cat, ind) => {
        return (
          <React.Fragment key={cat.sSlug}>
            <section id={cat.sSlug} className={`${styles.homeArticles} mb-3 mb-md-4`}>
              <h4 className="line-title mb-2 mb-md-3 mt-4 text-uppercase overflow-hidden">
                <span className="position-relative d-inline-block text-nowrap t-ellipsis ms-0 ms-sm-4 ms-lg-5">{cat?.sName}</span>
              </h4>
              {cat?.iHomePageModelId === '638f27b92ea1c44c64b42f69' && (
                <Row className="gx-2">
                  <Col xl={7}>
                    <ArticleBig data={cat?.aArticle[3]} />
                  </Col>
                  <Col xl={5}>
                    <ArticleMedium isSmall={true} data={cat?.aArticle[0]} />
                    <ArticleMedium isSmall={true} data={cat?.aArticle[1]} />
                    <ArticleMedium isSmall={true} data={cat?.aArticle[2]} />
                  </Col>
                </Row>
              )}
              {cat?.iHomePageModelId === '638f27b92ea1c44c64b42f6f' && (
                <Row className="gx-2">
                  <Col md={6}>
                    <ArticleBig data={cat?.aArticle[0]} />
                  </Col>
                  <Col md={6}>
                    <ArticleBig data={cat?.aArticle[1]} />
                  </Col>
                  <Col md={12}>
                    <Row className={`gx-2 flex-nowrap article-grid-list scroll-list ${styles.articleGridList}`}>
                      {cat?.aArticle[2]?.mappedArticle.map((g) => {
                        return (
                          <Col key={g._id} md={4} sm={5} xs="auto">
                            <ArticleGrid data={g} />
                          </Col>
                        )
                      })}
                    </Row>
                  </Col>
                </Row>
              )}
              {cat?.iHomePageModelId === '638f27b92ea1c44c64b42f6d' && (
                <Row className="gx-2">
                  <Col md={6}>
                    <ArticleSmall data={cat?.aArticle[1]} />
                    <ArticleSmall data={cat?.aArticle[2]} />
                    <ArticleSmall data={cat?.aArticle[3]} />
                  </Col>
                  <Col md={6}>
                    <ArticleBig data={cat?.aArticle[0]} />
                  </Col>
                  <Col md={12}>
                    <Row className={`gx-2 flex-nowrap article-grid-list scroll-list ${styles.articleGridList}`}>
                      {cat?.aArticle[4]?.mappedArticle.map((g) => {
                        return (
                          <Col key={g._id} md={4} sm={5} xs="auto">
                            <ArticleGrid data={g} />
                          </Col>
                        )
                      })}
                    </Row>
                  </Col>
                </Row>
              )}
              {cat?.iHomePageModelId === '651bc8846a7cd8be58a7feaf' && (
                <Row className="gx-2">
                  <Col xl={5}>
                    <ArticleMedium isSmall={true} data={cat?.aArticle[3]} />
                    <ArticleMedium isSmall={true} data={cat?.aArticle[4]} />
                    <ArticleMedium isSmall={true} data={cat?.aArticle[5]} />
                  </Col>
                  <Col xl={7}>
                    <ArticleBig data={cat?.aArticle[0]} />
                  </Col>
                  {cat?.aArticle[1]?.mappedArticle.map((g) => {
                    return (
                      <Col key={g._id} md={4} sm={5} xs="auto">
                        <ArticleGrid data={g} />
                      </Col>
                    )
                  })}

                  <Col xxl={8} md={7}>
                    <ArticleList data={cat?.aArticle[2]?.mappedArticle} />
                  </Col>
                </Row>
              )}
            </section>
          </React.Fragment>
        )
      })}
     {loading && articleLoader(['g', 's'])}
    </>
  )
}
HomePageArticle.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.object),
  widgetPosition: PropTypes.arrayOf(PropTypes.object)
}
export default HomePageArticle
